"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvalidationKeyForObject = exports.getCacheKeyForObject = void 0;
/* eslint-disable arrow-body-style */
const sortArray = (array) => {
    return array.sort((a, b) => {
        let stringA = a;
        let stringB = b;
        if (Array.isArray(a)) {
            // Array
            stringA = JSON.stringify(sortArray(a));
            stringB = JSON.stringify(sortArray(b));
        }
        else if (a instanceof Date) {
            // Date
            stringA = a.toISOString();
            stringB = b.toISOString();
        }
        else if (typeof a === 'object' && a !== null) {
            // Object
            stringA = JSON.stringify(a);
            stringB = JSON.stringify(b);
        }
        if (stringA < stringB) {
            return -1;
        }
        if (stringA > stringB) {
            return 1;
        }
        return 0;
    });
};
const valueToString = (value) => {
    let valueString = '';
    if (Array.isArray(value)) {
        const sortedValues = sortArray(value);
        const valueStrings = sortedValues.map((s) => valueToString(s));
        valueString = `[${valueStrings.join(',')}]`;
    }
    else if (value instanceof Date) {
        valueString = `${value.toISOString()}`;
    }
    else if (typeof value === 'object' && value !== null) {
        // We have object
        const stringValue = buildObjectCacheKeyString(value);
        valueString = `{${stringValue}}`;
    }
    else {
        valueString = value;
    }
    return valueString;
};
const buildObjectCacheKeyString = (valueObject) => {
    const objectKeys = Object.keys(valueObject);
    const sortedKeys = objectKeys.sort();
    const keyValues = [];
    for (const key of sortedKeys) {
        const value = valueObject[key];
        const valueString = valueToString(value);
        // To avoid undefined values in cache key
        if (valueString !== undefined) {
            keyValues.push(`${key}:${valueString}`);
        }
    }
    return keyValues.join(';');
};
const getCacheKeyForObject = (module, method, request) => {
    const cacheKey = `CA_${module}_${method}_${buildObjectCacheKeyString(request)}`;
    return cacheKey;
};
exports.getCacheKeyForObject = getCacheKeyForObject;
const getInvalidationKeyForObject = (module, method, request) => {
    const invalidationKey = `CA_IN_${module}_${method}_${buildObjectCacheKeyString(request)}`;
    return invalidationKey;
};
exports.getInvalidationKeyForObject = getInvalidationKeyForObject;
